import { Vault } from '@/model/vault'
import { createAppAsyncThunk } from '@/redux/utils'
import { requestBaeApi } from '@/utils/axios'

export const vaultNamespace = 'vault'

export interface ReadVaultsResponse {
  type_vaults: Vault[]
  total: number
}

export interface ReadVaultsRequest {
  creatorId: number
  pageNumber: number
  limit?: number
}

export const readVaults = createAppAsyncThunk(
  `${vaultNamespace}/readVaults`,
  async ({
    creatorId,
    pageNumber,
    limit = 20,
  }: ReadVaultsRequest) => {
    const { data } = await requestBaeApi<ReadVaultsResponse>({
      creatorId,
      url: '/api/v1/vaults',
      method: 'POST',
      data: {
        page_num: pageNumber,
        records: limit,
      },
    })
    return data
  },
)